<template>
  <nav class="hitrust-pay-header navbar navbar-expand-lg navbar-light bg-white fixed-top"
    :class="isFullHeader ? 'full-menu-header' : 'mobile-menu-header'">
    <StaticImage role="button" src="logo_hitrust.png" class="header-logo" @click="goToByName('Home')" />
    <!-- 手機板的選單開關-->
    <button class="header-toggler" :class="{ hidden: isFullHeader }" @click="toggleMenu">
      <span class="header-menu-icon" :class="{ 'is-cyber': isCyber }"></span>
    </button>
    <!--  PC版的MENU-->
    <FullMenu :MENU="MENU" />
  </nav>

  <MobileMenu v-model="mobileMenuOpen" :MENU="MENU" />
</template>

<script>
import FullMenu from "@/components/HeaderFullMenu.vue";
import MobileMenu from "@/components/HeaderMobileMenu.vue";
import { getMenu } from "@/utils/MenuUtil";

import { mapGetters } from "vuex";

export default {
  data() {
    const envData = this.env ? this.env.getData() : { MENU_COLLAPSE: "false" };

    return {
      mobileMenuOpen: false,
    };
  },
  components: {
    FullMenu,
    MobileMenu,
  },
  computed: {
    MENU() {
      return getMenu();
    },
    isCyber: function () {
      let meta = this.$route?.meta || {};
      return !!meta.isCyber;
    },
    ...mapGetters("device", {
      isFullHeader: "getIsFullHeader",
    }),
  },
  mounted: function () {
    this.initData();
  },
  methods: {
    initData: function () { },
    toggleMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    closeMenu() {
      this.mobileMenuOpen = false;
    },
    goToByName(name) {
      this.goTo({
        name: name,
      });
    },
  },
  props: {
    msg: String,
  },
  watch: {},
  setup(props, context) { },
};
</script>
<style scoped>
.full-menu-header {
  height: var(--menu-full-height);
  font-size: 18px;
  justify-content: flex-start;
  width: 100vw;
}

.mobile-menu-header {
  height: var(--menu-mobile-height);
  justify-content: space-between;
  width: 100vw;
}

.full-menu-header>.header-logo {
  width: 280px;
}

.mobile-menu-header>.header-logo {
  width: 160px;
}

.navbar-toggler {
  border-width: 0;
}

.header-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
  border-width: 0;
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.header-toggler.hidden {
  display: none;
}

.header-menu-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: 50%/100% 100% no-repeat;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30'%3E%3Cpath stroke='%238C1C36' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E");
}

.header-menu-icon.is-cyber {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30'%3E%3Cpath stroke='%23A387EC' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E");
}
</style>
